"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var createStyles_1 = __importDefault(require("@material-ui/core/styles/createStyles"));

var withStyles_1 = __importDefault(require("@material-ui/core/styles/withStyles"));

var Table_1 = __importDefault(require("@material-ui/core/Table"));

var TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));

var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));

var TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));

var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));

var rambda_1 = require("rambda");

var CustomTableCell = withStyles_1.default(function (theme) {
  return createStyles_1.default({
    body: {
      backgroundColor: "#FFFFFF",
      color: "#231F20",
      fontFamily: "Omnes",
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 4,
      opacity: 0.9,
      padding: "4px 16px 4px 16px"
    },
    head: {
      alignSelf: "flex-start",
      backgroundColor: "#F2F5F7",
      borderBottomColor: "#CCD9E0",
      borderBottomWidth: 2,
      color: theme.palette.common.black,
      fontFamily: "Omnes",
      fontSize: 14,
      fontWeight: 500,
      padding: "4px 16px 4px 16px",
      position: "sticky",
      top: 0,
      zIndex: 10
    }
  });
})(TableCell_1.default);
var styles = createStyles_1.default(function (theme) {
  return {
    root: {
      marginTop: theme.spacing.unit * 3,
      overflowX: "auto",
      width: "100%"
    },
    row: {
      "&:nth-of-type(odd)": {
        backgroundColor: "rgb(189, 211, 222)"
      }
    }
  };
});

var BB8Table = function BB8Table(_a) {
  var tableId = _a.tableId,
      cols = _a.cols,
      data = _a.data,
      classes = _a.classes,
      noDataComponent = _a.noDataComponent;
  return react_1.default.createElement(Table_1.default, {
    id: tableId,
    className: classes.table
  }, react_1.default.createElement(TableHead_1.default, null, react_1.default.createElement(TableRow_1.default, null, cols.map(function (_a, index) {
    var title = _a.title,
        headerCellProps = _a.headerCellProps;
    return react_1.default.createElement(CustomTableCell, __assign({
      key: index
    }, headerCellProps), title);
  }))), react_1.default.createElement(BB8TableBody, {
    cols: cols,
    data: data,
    classes: classes,
    noDataComponent: noDataComponent
  }));
};

var BB8TableBody = function BB8TableBody(_a) {
  var cols = _a.cols,
      data = _a.data,
      classes = _a.classes,
      noDataComponent = _a.noDataComponent;

  if (!data || !data.length) {
    return react_1.default.createElement(TableBody_1.default, null, react_1.default.createElement(TableRow_1.default, null, react_1.default.createElement(CustomTableCell, {
      colSpan: cols.length
    }, noDataComponent ? noDataComponent : "No data")));
  }

  return react_1.default.createElement(TableBody_1.default, null, data.map(function (row, i) {
    return react_1.default.createElement(TableRow_1.default, {
      hover: true,
      key: i,
      className: classes.row
    }, cols.filter(function (_a) {
      var id = _a.id;
      return id !== "colSpan";
    }).map(function (_a, index) {
      var id = _a.id,
          style = _a.style,
          tableCellProps = _a.tableCellProps,
          tableCellTemplate = _a.tableCellTemplate;
      return react_1.default.createElement(CustomTableCell, __assign({
        key: index,
        style: style
      }, tableCellProps), tableCellTemplate ? tableCellTemplate({
        id: id,
        data: rambda_1.path(id, row),
        row: row
      }) : rambda_1.path(id, row));
    }));
  }));
};

exports.default = withStyles_1.default(styles)(BB8Table);